// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ccf5779ad927ad13e {\r\n    font-size: var(--font-site-small);\r\n    font-style: italic;\r\n    color: #CCCCCC;\r\n    text-align: center;\r\n}", "",{"version":3,"sources":["webpack://./src/Components/Menu/SelectNote.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB","sourcesContent":[".sortNote {\r\n    font-size: var(--font-site-small);\r\n    font-style: italic;\r\n    color: #CCCCCC;\r\n    text-align: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sortNote": "ccf5779ad927ad13e"
};
export default ___CSS_LOADER_EXPORT___;
